import React from 'react';
import { Skeleton } from './skeleton';
import { useAppTranslations } from '@/hooks/useAppTranslations';

interface AuthLoadingSkeletonProps {
  message?: string;
}

export const AuthLoadingSkeleton: React.FC<AuthLoadingSkeletonProps> = ({
  message
}) => {
  const { t } = useAppTranslations();

  return (
    <div className="min-h-screen bg-app animate-pulse">
      <div className="max-w-sm mx-auto px-4 pt-4">
        {/* Header area */}
        <div className="mb-6">
          <Skeleton className="h-8 w-48 mb-2" />
          <Skeleton className="h-4 w-32" />
        </div>

        {/* Main content area */}
        <div
          className="rounded-3xl p-6 mb-6"
          style={{
            background: 'linear-gradient(135deg, rgba(82, 183, 136, 0.3) 0%, rgba(45, 90, 61, 0.3) 100%)',
          }}
        >
          <Skeleton className="h-6 w-40 mx-auto mb-4 bg-white/20" />
          <Skeleton className="h-12 w-20 mx-auto bg-white/20" />
        </div>

        {/* Cards area */}
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="p-6"
              style={{
                background: 'rgba(255, 255, 255, 0.5)',
                borderRadius: '24px',
              }}
            >
              <Skeleton className="h-4 w-24 mb-3" />
              <Skeleton className="h-8 w-16" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
